<script>
export default {
    name: 'SiteHeader',
    data: () => {
        return {
            windowHeight: 0,
            windowWidth: 0,
            currentScrollY: 0,
        }
    },
    mounted() {
        this.setWindowDimensions();
        this.onScroll();
        window.addEventListener('scroll', (e) => this.onScroll(e));
        window.addEventListener('resize', () => this.setWindowDimensions());
    },
    methods: {
        onScroll() {
            this.currentScrollY = window.pageYOffset;
        },
        getExpandedStyle() {
            if (this.currentScrollY < window.innerHeight * .15) {
                if (this.windowWidth > 960)
                    return { transform: 'scale(3.803030303) translate(48px, '+ (this.windowHeight * .115) +'px)' };
                else if (this.windowWidth > 720)
                    return { transform: 'scale(3) translate(0, '+ (this.windowHeight * .15) +'px)' };
                else
                    return { transform: 'scale('+ (this.windowWidth * .8) / 132 +') translate(0, '+ (this.windowHeight * .14) +'px)' };
            } else {
                return { transform: 'scale(1) translate(0, 0)' };
            }
        },
        setWindowDimensions() {
            this.windowHeight = window.innerHeight;
            this.windowWidth = window.innerWidth;
        },
    },
};
</script>

<template>
    <header class="site-header">
        <div class="site-header__content">
            <img src="../assets/images/logo-hug-gruppe.svg" alt="Logo Hug Gruppe" class="site-header__logo" v-bind:style="[getExpandedStyle()]" v-if="currentScrollY < windowHeight">
        </div>
    </header>
</template>

<style lang="scss" scoped>
.site-header {
    position: fixed;
    top: 0; left: 0;
    width: 100%;
    height: 5rem;
    z-index: 3;
}
.site-header__content {
    box-sizing: border-box;
    width: 17.1875rem;
    margin: 0 auto;
    padding: 2.7rem 0.78125rem 0;
    font-size: 1.125rem;
    line-height: 1.222;

    @media (max-width: 960px) {
        width: 100%;
        padding: 1.5rem 0;
    }
}
.site-header__logo {
    width: 8.25rem;
    transition: transform 500ms;

    @media (max-width: 960px) {
        display: block;
        margin: auto;
    }
}
</style>
